import { className } from 'lib/css'
import { useEffect, useState } from 'preact/hooks'
import Icon from 'ui/components/layout/icon'

export default function Error({ id, error }) {
  const [isAvailable, setIsAvailable] = useState(false)
  useEffect(() => {
    const timerId = setTimeout(() => setIsAvailable(true), 300) // 300 = magic number, could be less or more
    return () => clearTimeout(timerId) // clear timer if error is mounted+unmounted within 300
  }, [])

  return (
    <div
      className={className('error')}
      aria-live="assertive"
      aria-atomic="true"
    >
      {isAvailable && error && (
        <span id={id} className={className('error__message')}>
          <Icon name="error" size="16" alt="" />
          {error}
        </span>
      )}
    </div>
  )
}
